import * as AccessibleIcon from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

const ClickRight: React.FC<SVGProps<SVGSVGElement>> = props => {
  const label = 'ClickRight'
  return (
    <AccessibleIcon.Root label={label}>
    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.2929 13.7929C16.6834 13.4024 17.3166 13.4024 17.7071 13.7929L23.7071 19.7929C24.0976 20.1834 24.0976 20.8166 23.7071 21.2071L17.7071 27.2071C17.3166 27.5976 16.6834 27.5976 16.2929 27.2071C15.9024 26.8166 15.9024 26.1834 16.2929 25.7929L21.5858 20.5L16.2929 15.2071C15.9024 14.8166 15.9024 14.1834 16.2929 13.7929Z" fill="#1A0244"/>
            </svg>



    </AccessibleIcon.Root>
  )
}

export default ClickRight
